import type {Kicker} from '@github-ui/remote-form'
import {fromEvent} from '@github-ui/subscription'
import {observe} from '@github-ui/selector-observer'
import {remoteForm} from '@github-ui/remote-form'

observe('.js-discussions-goto-answer-button', {
  add: el => {
    try {
      const href = el.getAttribute('href')
      /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
      const answerElement = document.querySelector<HTMLButtonElement>(href!)

      if (answerElement) {
        fromEvent(
          el,
          'click',
          e => {
            if (href) {
              e.preventDefault()
              let blockScrollOption: 'center' | 'start' = 'center'

              // If the answer's height is greater than or equal to the windows
              // height, we want to use the `start` option which aligns the top of
              // the answer with the top of the viewport
              if (answerElement.getBoundingClientRect().height >= window.innerHeight) {
                blockScrollOption = 'start'
              }
              answerElement.scrollIntoView({behavior: 'smooth', block: blockScrollOption})

              // Set focus and tab index to actual comment container
              /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
              const answerComment = answerElement.querySelector<HTMLElement>('.js-targetable-element')!
              if (answerComment) {
                answerComment.tabIndex = 0
                answerComment.focus({preventScroll: true})
              }
            }
          },
          {capture: true},
        )
      }
    } catch (e) {
      if (e instanceof DOMException) {
        // ignore
      } else {
        throw e
      }
    }
  },
})

observe('.js-discussions-title-container', {
  add: element => {
    const answeredPillButton = element.querySelector<HTMLElement>('.js-discussions-goto-answer-button')

    if (answeredPillButton) {
      removeMarkAsAnswerButtons()
    } else {
      addMarkAsAnswerButtons()
    }
  },
})

observe('.js-discussions-trigger-unmark-answer', {
  add: button => {
    fromEvent(button, 'click', event => {
      event.preventDefault()
      const form = document.querySelector<HTMLFormElement>('.js-discussion-comment-unmark-answer')

      if (form) {
        form.requestSubmit()
      }
    })
  },
})

observe('.js-discussions-trigger-verify-answer', {
  add: button => {
    fromEvent(button, 'click', event => {
      event.preventDefault()
      const form = document.querySelector<HTMLFormElement>('.js-discussion-comment-verify-answer')

      if (form) {
        form.requestSubmit()
      }
    })
  },
})

observe('.js-discussions-trigger-unverify-answer', {
  add: button => {
    fromEvent(button, 'click', event => {
      event.preventDefault()
      const form = document.querySelector<HTMLFormElement>('.js-discussion-comment-unverify-answer')
      if (form) {
        form.requestSubmit()
      }
    })
  },
})

function removeMarkAsAnswerButtons() {
  const discussion = document.querySelector<HTMLElement>('.js-discussion')

  if (discussion) {
    discussion.classList.add('answered')
  }
}

function addMarkAsAnswerButtons() {
  const discussion = document.querySelector<HTMLElement>('.js-discussion')

  if (discussion) {
    discussion.classList.remove('answered')
  }
}

remoteForm('.js-discussion-comment-mark-answer', async function (form, wants) {
  await replaceAnswerForm(form, wants)
})

remoteForm('.js-discussion-comment-unmark-answer', async function (form, wants) {
  await replaceAnswerForm(form, wants)
})

remoteForm('.js-discussion-comment-verify-answer', async function (form, wants) {
  await replaceAnswerForm(form, wants)
})

remoteForm('.js-discussion-comment-unverify-answer', async function (form, wants) {
  await replaceAnswerForm(form, wants)
})

async function replaceAnswerForm(form: HTMLFormElement, wants: Kicker) {
  const response = await wants.html()

  const commentContainer = form.closest('.js-nested-comment-container')
  const verified_answer = response.url.includes('verified_answer')

  if (commentContainer?.classList.contains('color-bg-success')) {
    if (verified_answer) {
      commentContainer.classList.add('color-bg-accent')
      commentContainer.classList.add('timeline-child-comment-verified-border')
    }
    commentContainer.classList.remove('color-bg-success')
    commentContainer.classList.remove('timeline-child-comment-answer-border')
  } else {
    if (verified_answer) {
      commentContainer?.classList.remove('color-bg-accent')
      commentContainer?.classList.remove('timeline-child-comment-verified-border')
    }
    commentContainer?.classList.add('color-bg-success')
    commentContainer?.classList.add('timeline-child-comment-answer-border')
  }

  let target: Element = form
  const container = form.closest('[data-replace-remote-form-target]')
  if (container) {
    const id = container.getAttribute('data-replace-remote-form-target')
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    target = id ? document.getElementById(id)! : container
  }
  target.replaceWith(response.html)
}
